import React from 'react';
import { useTranslation } from 'react-i18next';

import { useStyles } from './SubscriptionPlanPrices.styles';
import theme from '../../../styles/theme';
import FlexibleColumnsTable from '../../../components/reusable/Table/FlexibleColumnsTable';
import { useSubscriptionPlanPricesComponent } from './useSubscriptionPlanPricesComponent';
import ConfirmDialog from '../../../components/reusable/confirm-dialog/ConfirmDialog';
import Search from '../../../components/reusable/search/Search';
import AppDialog from '../../../components/reusable/app-dialog/AppDialog';
import AddSubscriptionPlanPrice from './add-subscription-plan-price/AddSubscriptionPlanPrice';
import { Box } from '@mui/material';
import AppButton from '../../../components/designe/app-button/AppButton';
import { useAccess } from '../../../hooks/useAccess';
import { SubscriptionPlanPricesFilter } from './SubscriptionPlanPricesFilter';

const SubscriptionPlanPricePrices = (props) => {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    sortedArray,
    columnsList,
    order,
    orderBy,
    cellReducers,
    onSort,
    onSortColumns,
    itemForDelete,
    setItemForDelete,
    onItemDelete,
    filter,
    setFilter,
    showEditModal,
    setShowEditModal,
    itemForEditing,
    setItemForEditing,
    filterFormik,
    filterCurrentOptions,
  } = useSubscriptionPlanPricesComponent(classes);
  const { access } = useAccess();

  return (
    <div className={classes.wrapper}>
      <SubscriptionPlanPricesFilter
        formik={filterFormik}
        filterCurrentOptions={filterCurrentOptions}
      />
      <Box display="flex" gap={1} alignItems="center" marginBottom={2}>
        <Search fullWidth value={filter} onChange={setFilter} />
        {access?.subscriptionPlanPrices?.canCreate && (
          <AppButton onClick={() => setShowEditModal(true)}>
            {t('common.add')}
          </AppButton>
        )}
      </Box>
      <FlexibleColumnsTable
        data={sortedArray}
        columnsList={columnsList}
        order={order}
        orderBy={orderBy}
        onSort={onSort}
        classes={classes}
        onSortColumns={onSortColumns}
        cellReducers={cellReducers}
        onSelectAllRows={() => {}}
        stickyHeader={true}
      />
      <ConfirmDialog
        open={!!itemForDelete}
        onClose={() => setItemForDelete(null)}
        title={t('common.delete')}
        onSubmit={() => onItemDelete()}>
        {t('common.deleteQuestion')}
      </ConfirmDialog>

      <AppDialog
        open={!!showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setItemForEditing(null);
        }}
        title={
          itemForEditing
            ? t('superAdminDashboard.editSubscriptionPlanPrice')
            : t('superAdminDashboard.addSubscriptionPlanPrice')
        }>
        <AddSubscriptionPlanPrice
          subscriptionPlanPrice={itemForEditing}
          onClose={() => {
            setShowEditModal(false);
            setItemForEditing(null);
          }}
        />
      </AppDialog>
    </div>
  );
};

export default SubscriptionPlanPricePrices;
